import { Model } from '@viddsee/server-api-client';

export const CollectionInfoFriendlyTypeMap: Record<Model.VideoCollection.InfoType, string> = {
  channel: 'Channel',
  // eslint-disable-next-line @typescript-eslint/camelcase
  channel_edition: 'Channel Edition',
  // eslint-disable-next-line @typescript-eslint/camelcase
  channel_edition_playlist: 'Channel Playlist',
  // eslint-disable-next-line @typescript-eslint/camelcase
  user_playlist: 'User Playlist',

  series: 'Series',
  // eslint-disable-next-line @typescript-eslint/camelcase
  series_season: 'Series',
};
